import { Link } from "react-router-dom";
import { Seo } from "@/components/Seo";
import { PageHeader } from "@/components/PageHeader";

export default function NotFound() {
  return (
    <div data-testid="not-found-page">
      <Seo title="Page Not Found" description="The page you requested does not exist." />
      <PageHeader overline="Error 404" title="Page not found" lede="The address you followed does not exist on this site. It may have moved or been retired." />
      <section className="mx-auto flex max-w-4xl flex-wrap gap-4 px-4 py-16 sm:px-6">
        <Link to="/" data-testid="notfound-home-link" className="btn-primary">Home</Link>
        <Link to="/services" data-testid="notfound-services-link" className="btn-outline">Services</Link>
        <Link to="/contact" data-testid="notfound-contact-link" className="btn-outline">Contact</Link>
      </section>
    </div>
  );
}
